export default __webpack_public_path__ + "static/media/2.81e14796.PNG";